import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryCreateInnerRideChangeRideEvent } from "../../../../common/types/order-details-history-change-ride-event";

type OrderDetailsHistoryEntryChangeRideContentCreateInnerRideProps = {
  event: OrderDetailsHistoryEntryCreateInnerRideChangeRideEvent;
};

const OrderDetailsHistoryEntryChangeRideContentCreateInnerRideComponent: FC<
  OrderDetailsHistoryEntryChangeRideContentCreateInnerRideProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .createInnerRide;

  return (
    <div className="order_details_history_entry_list_item_content__section">
      <div className="order_details_history_entry_list_item_content__label">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryChangeRideContentCreateInnerRideComponent;
